module.exports = __webpack_public_path__ + "static/media/1250_screenshots_2012-09-05_00001.f46927c2.jpg";